import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { AddEditDoctorComponent } from './addEditDoctor.component';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { DoctorModel } from '../../../model/index';
import { DoctorService } from '../../../services/index';

@Component({
    selector: 'doctor-tab',
    templateUrl: './doctor.component.html',
})
export class DoctorMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public doctordata: any[] = [];

    isLoadMask: Promise<any>;
    doctorData: DoctorModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    constructor(public store: Store<fromRootStore.State>, private doctorService: DoctorService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Name', prop: 'name', cellClass: 'cell-left', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Hospital Name', prop: 'hospital_name', width: 200, minWidth: 200, maxWidth: 200, cellClass: 'cell-left' },
            { name: 'Designation', prop: 'designation', width: 130, minWidth: 130, maxWidth: 130, cellClass: 'cell-left' },
            { name: 'City', prop: 'city', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left' },
            { name: 'Source', prop: 'source', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left' },
            { name: 'Status', prop: 'doctor_status', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left' },
            { name: 'SMS Disabled', prop: 'sms_status', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-left' },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getDoctorList();
    }

    onScroll() {
        this.suppressPaging = true;

        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getDoctorList();
    }

    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getDoctorList();
    }

    getDoctorList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.doctorService
            .getDoctorList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.doctorData = res.data;
            });
    }

    downloadCurrentData(): void {
        let params = {
            start: '0', limit: '99999',
            orderColumn: `${this.page.orderBy}`, orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.doctorService.getDoctorList(params).then((res: any) => {
            const rows = (res.data || []).map((r, i) => ({
                'SNo': i + 1,
                'NAME': r.name,
                'HOSPITAL NAME': r.hospital_name,
                'DESIGNATION': r.designation,
                'CITY': r.city,
                'SOURCE': r.source,
                'STATUS': r.doctor_status,
                'SMS DISABLED': r.sms_status
            }));
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'Doctor_' + moment().format('DD-MM-YYYY') + '.xlsx');
        });
    }

    bsModalRef: BsModalRef;
    public onAddEditDoctor(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        this.bsModalRef = this.modalService.show(AddEditDoctorComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Doctor Details';
        this.bsModalRef.content.doctordata = Object.assign({}, row);
        this.bsModalRef.content.doctorLoadEvent.subscribe(($e) => {
            that.getDoctorList();
            that.store.dispatch(new commonActions.LoadAllReference());
        });
    }

    onDeleteDoctor(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Doctor: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.doctorService
                .deleteDoctor(row.doctor_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getDoctorList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctor/doctor.component.ts